module.exports = [
    {
        "field": "title",
        "localized": "Title"
    },
    {
        "field": "abstractNote",
        "localized": "Abstract"
    },
    {
        "field": "websiteTitle",
        "localized": "Website Title"
    },
    {
        "field": "websiteType",
        "localized": "Website Type"
    },
    {
        "field": "date",
        "localized": "Date"
    },
    {
        "field": "shortTitle",
        "localized": "Short Title"
    },
    {
        "field": "url",
        "localized": "URL"
    },
    {
        "field": "accessDate",
        "localized": "Accessed"
    },
    {
        "field": "language",
        "localized": "Language"
    },
    {
        "field": "rights",
        "localized": "Rights"
    },
    {
        "field": "extra",
        "localized": "Extra"
    }
]


//////////////////
// WEBPACK FOOTER
// ./static/itemFields/webpage.js
// module id = NC93
// module chunks = 1